import {
    CONFIRMED_GET_FACING_DIRECTION
} from '../actions/FacingDirection/FacingDirectionTypes';
const initialState = {
    facingDirection: [],
    loading: false,
};

function FacingDirectionReducer(state = initialState, actions) {
    switch (actions.type) {
        case 'FACING_DIRECTION_LOADING':
            return {
                ...state,
                loading: true,
            };
        case CONFIRMED_GET_FACING_DIRECTION:
            return {
                ...state,
                facingDirection: actions.payload,
                loading: false,
            };
        default:
            return state;
    }
}

export {FacingDirectionReducer};